<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M10.0007 15.1715L19.1927 5.97852L20.6077 7.39252L10.0007 17.9995L3.63672 11.6355L5.05072 10.2215L10.0007 15.1715Z"
        v-bind:fill="color" />
    </g>
    <defs>
      <clipPath id="clip0_2093_15647">
        <rect width="24" height="24" v-bind:fill="color" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>